import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  
  connect() {
    this.element.addEventListener('change', this.change.bind(this))
  }

  disconnect() {
    this.element.removeEventListener('change', this.change)
  }

  change(event) {
    this.updateUrl(event)
  }

  updateUrl(event) {
    console.log('updateUrl', event)
    const selectedOption = event.target.selectedOptions[0]
    const selectedPoolerId = selectedOption.value
    
    let url = window.location.pathname
    if (selectedPoolerId == 'all') {
      alert('All Poolers not implemented yet')
    } else {
      console.log('selectedPoolerId', selectedPoolerId)
      console.log('currentUrl', url)
      // If URL contains /clients/<number>, replace the number and keep only first 5 path segments
      // This will typically mean the user stays on the same page/section but we remove any paths/id's that may be client specific.
      // For Example:
      // /clients/123/poolers/456/dashboard
      // /clients/123/poolers/456/movements
      // /clients/123/poolers/456/sites
      // /clients/123/poolers/456/tracking_sheets
      // /clients/123/poolers/456/invoices
      // /clients/123/poolers/456/exports
      // /clients/123/poolers/456/balance_logs
      // /clients/123/poolers/456/rate_cards
      // /clients/123/poolers/456/locations
      // /clients/123/poolers/456/reports
      // /clients/123/poolers/456/balances
      
      const baseUrl = url.split('/').slice(0, 6).join('/') // note that the path starts with a / also 
      if (selectedPoolerId && url.includes('/poolers/')) {
        url = url.replace(/\/poolers\/\d+/, `/poolers/${selectedPoolerId}`)
      }
      console.log('url', url)
    }

    Turbo.visit(url)
  }

}